import { EndUserLicenseAgreementItem } from '../models/end-user-license-agreement.model';
import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EndUserLicenseAgreementListService } from './end-user-license-agreement-list.service';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import {
  EndUserLicenseAgreementListLoad,
  EndUserLicenseAgreementListInitialState,
} from './end-user-license-agreement-list.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type EulaListStateModel = ListServerPaginationStateModel<EndUserLicenseAgreementItem>;

const initialState: EulaListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<EulaListStateModel>({
  name: 'endUserLicenseAgreementList',
  defaults: initialState,
})
@Injectable()
export class EndUserLicenseAgreementListState {
  constructor(
    private eulaListService: EndUserLicenseAgreementListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: EulaListStateModel): EulaListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: EulaListStateModel): EndUserLicenseAgreementItem[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: EulaListStateModel): boolean {
    return state.loaded;
  }

  @Action(EndUserLicenseAgreementListLoad)
  getEndUserLicenseAgreementList(
    ctx: StateContext<EulaListStateModel>,
    { payload }: EndUserLicenseAgreementListLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.eulaListService.getEulaList(payload).pipe(
      map((eulaListStateModel: EulaListStateModel) => {
        ctx.patchState({ ...eulaListStateModel, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(EndUserLicenseAgreementListInitialState)
  setInitialState(ctx: StateContext<EulaListStateModel>): void {
    ctx.setState(initialState);
  }
}
